<template>
  <div>
    <!-- <div class="mainTitle">订单管理</div> -->
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="所属机构" prop="sourceType">
              <el-select style="width:100%" v-model="searchForm.agentId" clearable>
                <el-option v-for="i in organizations" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="订单状态" prop="orderState">
              <!-- <el-input v-model="searchForm.orderState" placeholder="请输入订单状态（待付款/已支付/已退款/已取消）" auto-complete="off"></el-input> -->
              <el-select v-model="searchForm.orderState" clearable placeholder="请选择">
                <el-option
                  v-for="i in orderStateForm"
                  :key="i.key"
                  :label="i.value"
                  :value="i.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="订单来源" prop="sourceType">
              <el-select v-model="searchForm.sourceType" clearable placeholder="请选择">
                <el-option
                  v-for="i in orderSourceForm"
                  :key="i.key"
                  :label="i.value"
                  :value="i.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="下单时间" prop="createTime">
              <el-date-picker
                style="width:100%"
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="createTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="订单编号" prop="number">
              <el-input
                v-model="searchForm.number"
                placeholder="请输入订单编号"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="姓名/号码" prop="remark">
              <el-input
                v-model="searchForm.studentName"
                placeholder="请输入"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="订单备注" prop="remark">
              <el-input
                v-model="searchForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="付款时间" prop="paidTime">
              <el-date-picker
                style="width:100%"
                v-model="paidTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="paidTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6" style="float:right">
            <!-- <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>-->
            <el-button-group style="float:right">
              <el-button
                type="primary"
                @click="pageList(),getOrderListStats()"
                icon="el-icon-search"
              >查询</el-button>
              <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div>
        <span style="font-size:16px;font-weight:300">订单数量：</span>
        <span style="font-size:16px">{{orderListStats.count}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span style="font-size:16px;font-weight:300">金额合计：</span>
        <span style="font-size:16px">{{orderListStats.amount}}元</span>
      </div>
      <el-table
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
      >
        <el-table-column prop="orderState" label="订单状态" align="center" width="90">
          <template slot-scope="row">
            <span class="paid">{{row.row.orderState}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="所属机构" width="120"></el-table-column>
        <el-table-column prop="number" label="单号" width="150"></el-table-column>
        <el-table-column prop="student.name" label="学员姓名" width="100"></el-table-column>
        <el-table-column prop="student.mobile" label="电话" width="100"></el-table-column>
        <el-table-column prop="sourceType" label="订单来源"></el-table-column>
        <el-table-column prop="totalAmount" label="小计"></el-table-column>
        <el-table-column prop="paidState" label="付款方式">
          <template
            slot-scope="row"
          >{{row.row.paidState==1?row.row.orderPaymentList[0].channel:"未支付"}}</template>
        </el-table-column>

        <el-table-column width="150" prop="createTime" label="下单时间"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <!-- <span @click="showPayDetail(scope.row)">查看</span> -->
              <i class="iconfont iconchakan mainColor" title="查看" @click="showPayDetail(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog title="订单信息" :visible.sync="payFormVisible" width="800px" left>
      <el-row :gutter="20">
        <el-col :span="24">
          <span style="font-size:14px;font-weight:500;color:#000;">订单信息</span>
          <span style="margin-left:20px;" class="paid">{{payForm.orderState}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:20px;">
        <el-col :span="8">
          <span>订单编号：{{payForm.number}}</span>
        </el-col>
        <el-col :span="8">
          <span>学员姓名：{{payForm.student!=null&&payForm.student!=''?payForm.student.name:''}}</span>
        </el-col>
        <el-col :span="8">
          <span>学员电话：{{payForm.student!=null&&payForm.student!=''?payForm.student.mobile:''}}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:20px;">
        <!-- <el-col :span="8">
          <span>是否开票：{{}}</span>
        </el-col>-->
        <el-col :span="8">
          <span>订单来源：{{payForm.sourceType}}</span>
        </el-col>
        <el-col :span="8">
          <span>支付IP：{{payForm.ip}}</span>
        </el-col>
        <el-col :span="8">
          <span>下单时间：{{payForm.createTime}}</span>
        </el-col>
      </el-row>
      <el-table
        :data="payForm.orderItemList"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
      >
        <el-table-column prop="goodsName" label="商品名称"></el-table-column>
        <el-table-column prop="goodsPrice" label="单价"></el-table-column>
        <el-table-column prop="goodsQuantity" label="数量"></el-table-column>
        <el-table-column prop="goodsTotalAmount" label="总价"></el-table-column>
      </el-table>
      <div style="margin-top:20px;font-size:14px;font-weight:500;color:#000;">订单实付金额</div>
      <el-table
        :data="payForm.orderPaymentList"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
      >
        <el-table-column prop="channel" label="支付类型"></el-table-column>
        <el-table-column prop="paymentTime" label="时间"></el-table-column>
        <el-table-column prop="tradeAmount" label="实付金额(元)"></el-table-column>
        <el-table-column prop="tradePaymentAccount" label="付款账户"></el-table-column>
        <el-table-column prop="tradeState" label="状态"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paidTime: [],
      createTime: [],
      orderStateForm: [],
      orderSourceForm: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      payFormVisible: false,
      searchForm: {
        orderState: "",
        sourceType: "",
        orderTime: "",
        type: "",
        number: "",
        ip: "",
        remark: ""
      },
      payForm: {
        student: {},
        goodsInfoList: {}
      },
      formLabelWidth: "80px",
      selection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/orderInfo/upload`,
      fileList: [],
      loading: true,
      orderListStats: {},
      organizations: []
    };
  },
  methods: {
    paidTimeChange() {
      if (this.paidTime) {
        this.searchForm.paidTimeBegin = this.paidTime[0];
        this.searchForm.paidTimeEnd = this.paidTime[1];
      } else {
        this.searchForm.paidTimeBegin = "";
        this.searchForm.paidTimeEnd = "";
      }
    },
    createTimeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    showPayDetail(row) {
      this.payForm = row;
      console.log("this.payForm", this.payForm);
      this.payFormVisible = true;
    },
    getOrderInfo(row) {
      // this.api.orderInfo
      //   .getOrderInfo({
      //     id: this.selection
      //   })
      //   .then(result => {
      //     this.editForm = result.data;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });
    },
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.orderInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getOrderListStats() {
      let obj = JSON.parse(JSON.stringify(this.searchForm));
      delete obj.pageSize;
      delete obj.pageNumber;
      this.api.orderInfo.getOrderListStats(obj).then(result => {
        this.orderListStats = result.data;
      });
    },
    addOrderInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .addOrderInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateOrderInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.orderInfo
            .updateOrderInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    reset() {
      this.loading = true;
      this.$refs.searchForm.resetFields();
      this.createTime = [];
      this.paidTime = [];
      this.searchForm.createTimeBegin = "";
      this.searchForm.paidTimeBegin = "";
      this.searchForm.createTimeEnd = "";
      this.searchForm.paidTimeEnd = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.getOrderListStats();
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    getOrderSourceType() {
      this.api.orderInfo.getOrderSourceType().then(result => {
        this.orderSourceForm = result.data;
      });
    },
    getAgentInfoList() {
      this.api.agentUserInfo.getAgentInfoList().then(result => {
        this.organizations = result.data;
      });
    },
    getOrderState() {
      this.api.orderInfo.getOrderState().then(result => {
        this.orderStateForm = result.data;
      });
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getOrderInfo();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getOrderListStats();
    this.getOrderState();
    this.getOrderSourceType();
    this.getAgentInfoList();
  }
};
</script>
<style  scoped>
.el-select {
  width: 100% !important;
}
.paid {
  padding: 3px 14px 3px 14px;
  color: #fff;
  background: rgb(36, 210, 181);
  border: solid 1px rgb(36, 210, 181);
  text-align: center;
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/orderInfo/index.vue